import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox/';

import { dangerousGoodsDhlEcommerce } from '../../../../../../src/services/other-shipping-options/constants';
import { useFulfillmentPlannerContext } from '../../../../../fulfillment-planner/context';
import style from '../inputs.module.less';
import GoodsTypeDropdown from './goods-type-dropdown';
import messages from './messages';

/**
 * @callback UpdateOption
 * @param {{ id: string, value: boolean|{ dangerousGoodsDhlDomestic: string|null, dangerousGoodsDhlInternational:string|null}}} arg
 */

/**
 * Component for handling dangerous goods shipping option for dhl carrier.
 * @param {object} props - The component props.
 * @param {React.ReactNode} props.label - The label for the checkbox.
 * @param {boolean} props.checked - The checked state of the checkbox.
 * @param {{dangerousGoodsDhlDomestic: string, dangerousGoodsDhlInternational: string}} props.optionData - The data for the dangerous goods option.
 * @param {UpdateOption} props.updateOption - The function to update the dangerous goods option.
 * @returns {JSX.Element} The rendered DangerousGoods component.
 */
export const DangerousGoodsDHLEcom = ({ label, checked = false, optionData, updateOption }) => {
  const dangerousGoodsDhlDomestic = optionData?.dangerousGoodsDhlDomestic;
  const dangerousGoodsDhlInternational = optionData?.dangerousGoodsDhlInternational;
  const { isInternational } = useFulfillmentPlannerContext();
  const [goodsClassification, setGoodsClassification] = useState(
    isInternational ? dangerousGoodsDhlInternational : dangerousGoodsDhlDomestic,
  );
  const [isOptionChecked, setIsOptionChecked] = useState(checked);
  const onCheckChanged = useCallback(
    (isChecked) => {
      setIsOptionChecked(isChecked);
      if (!isChecked) {
        updateOption({ id: dangerousGoodsDhlEcommerce, value: false });
        return;
      }
      const newValue = {
        dangerousGoodsDhlDomestic: !isInternational ? goodsClassification : null,
        dangerousGoodsDhlInternational: isInternational ? goodsClassification : null,
      };
      updateOption({ id: dangerousGoodsDhlEcommerce, value: newValue });
    },
    [goodsClassification, isInternational, updateOption],
  );

  return (
    <div className={style['dangerous-goods-dhl']}>
      <div>
        <Checkbox checked={isOptionChecked} label={label} onChange={onCheckChanged} />
      </div>
      {isOptionChecked ? (
        <div className={style['dangerous-goods-selector']}>
          <label>
            <FormattedMessage {...messages.typeOfGoods} />
          </label>
          <GoodsTypeDropdown
            goodsClassification={goodsClassification}
            isInternational={isInternational}
            setGoodsClassification={setGoodsClassification}
            updateOption={updateOption}
          />
        </div>
      ) : null}
    </div>
  );
};
